export interface ISelectListItem {
  displayName: string;
  id: string;
  isRemoveButtonShown?: boolean;
  canAddToContentBody?: boolean;
  // View-only: set when the item arrived via an accepted smart link, never persisted.
  isSmartLinked?: boolean;
  // View-only: set when the item was auto-added by AI auto-tagging, never persisted.
  isAutoTagged?: boolean;
}
export class SelectListItem implements ISelectListItem {
  isSmartLinked?: boolean;
  isAutoTagged?: boolean;

  constructor(
    public id: string,
    public displayName: string,
    public isRemoveButtonShown: boolean = true,
    public canAddToContentBody: boolean = false,
  ) {}
}
